import React from "react";
import {useHistory} from "react-router-dom";
import {useIntl} from "react-intl";

interface ActionColumnProps {
    callForPapersSlug: string;
    submissionId: string;
    reviewId?: string;
}

/**
 * Rendert die "Aktionen"-Tabellen-Zelle für das Einreichungslisting
 *
 * @param cell
 * @constructor
 */
const ActionColumn: ({callForPapersSlug, submissionId, reviewId}: ActionColumnProps) => JSX.Element = (
    {callForPapersSlug, submissionId, reviewId}: ActionColumnProps
) => {
    const history = useHistory();
    const intl = useIntl();

    /**
     * Öffnet die Detailseite einer Einreichung anhand des C4P-Slugs und der Einreichungs-ID
     */
    const navigateToDetail: () => void = () => {
        history.push(`/${callForPapersSlug}/edit/${submissionId}`);
    }

    /**
     * Öffnet die Bewertungsansicht einer Einreichung anhand des C4P-Slugs und der Einreichungs-ID
     */
    const navigateToReview: () => void = () => {
        history.push(`/${callForPapersSlug}/review/${submissionId}/${reviewId}`);
    }

    return (
        <>
            {reviewId ?
                <span className='btn btn-link' onClick={navigateToReview}>
                    <i className='fa fa-2x fa-star-half-o'
                       data-toggle="tooltip"
                       title={intl.formatMessage({id: "myarea.listing.column.body.actions.review"})}
                    />
                </span>
                :
                <span className='btn btn-link' onClick={navigateToDetail}>
                    <i className='fa fa-2x fa-pencil'
                       data-toggle="tooltip"
                       title={intl.formatMessage({id: "myarea.listing.column.body.actions.edit"})}
                    />
                </span>
            }
        </>
    );
}

export default ActionColumn;
